import { ICompanyDetailsWebSocket } from 'global/TableOrderbookWidget/types';
import moment from 'moment';
import { UseLivePriceRes } from './useLivePrice.types';

export const natsLivePriceFormatter = (
  liveprice: LivePriceResponse,
): UseLivePriceRes => ({
  // orderbook col 1
  previous: liveprice.prev,
  change: liveprice.change.value,
  percentage_change: liveprice.change.percentage,
  frequency: liveprice.frequency,

  // orderbook col 2
  open: liveprice.open,
  high: liveprice.high,
  low: liveprice.low,
  // fbuy: 0, // Not Exist in LivePrice Nats

  // orderbook col 3
  volume: liveprice.volume,
  value: liveprice.value,
  average: liveprice.average,
  // fsell: 0, // Not Exist in LivePrice Nats

  // misc
  close: liveprice.close,
  lastprice: liveprice.lastprice,
  date: liveprice.date,
  stockCode: liveprice.stockCode,
});

export const oldLivePriceFormatter = ({
  ohlc,
  widget,
  sym,
}: ICompanyDetailsWebSocket): UseLivePriceRes => ({
  // orderbook col 1
  previous: ohlc.previous,
  change: widget[sym].price_change,
  percentage_change: widget[sym].percentage_change,
  frequency: ohlc.frequency,

  // orderbook col 2
  open: ohlc.Open,
  high: ohlc.High,
  low: ohlc.Low,
  fbuy: ohlc.foreign_buy,

  // orderbook col 3
  volume: ohlc.volume,
  value: ohlc.value,
  average: ohlc.avg_price,
  fsell: ohlc.foreign_sell,

  // misc
  close: ohlc.Close,
  lastprice: widget[sym].lastprice,
  date: ohlc.date_formated
    ? moment(ohlc.date_formated, 'YYYY-MM-DD HH:mm:ss').format()
    : '',
  stockCode: sym,
});

/**
 * Defined Type Guards.
 * @link https://www.typescriptlang.org/docs/handbook/2/narrowing.html#using-type-predicates
 */
export const isNatsLivePriceResponse = (
  rawLivePrice: LivePriceResponse | ICompanyDetailsWebSocket,
): rawLivePrice is LivePriceResponse =>
  (rawLivePrice as LivePriceResponse).stockCode !== undefined;

// Formatted Nats
// {
//     "previous": 4710,
//     "change": -10,
//     "percentage_change": -0.21231422505307856,
//     "frequency": 13409,
//     "open": 4760,
//     "high": 4770,
//     "low": 4700,
//     "volume": 89721000,
//     "value": 424632501000,
//     "average": 4733,
//     "close": 4700,
//     "lastprice": 4700,
//     "date": "2023-03-15T15:09:29.728289+07:00",
//     "stockCode": "BBRI"
// }

// Raw Nats
// {
//   "stockCode": "GOTO",
//   "lastprice": 120,
//   "volume": 2619794600,
//   "high": 125,
//   "low": 119,
//   "open": 124,
//   "frequency": 20846,
//   "average": 122,
//   "date": "2023-03-15T14:48:21.762801+07:00",
//   "close": 120,
//   "prev": 121,
//   "value": 318585803700,
//   "change": {
//     "value": -1,
//     "percentage": -0.8264462809917356
//   },
//   "orderVerb": "B",
//   "quantity": "85200",
//   "sequenceNumber": "3963134",
//   "orderBookId": "4311",
//   "orderNumber": "202303150001779420",
//   "matchNumber": "202303150001127170",
//   "board": "BOARD_TYPE_RG"
// }

// Raw Old
// {
//   "sym": "BBCA",
//   "date_unix": 1678865974,
//   "ohlc": {
//     "Adj_Close": 8350,
//     "Close": 8350,
//     "High": 8475,
//     "Low": 8325,
//     "Open": 8450,
//     "volume": 46148300,
//     "date_unix": 1678865974,
//     "date_formated": "2023-03-15 14:39:34",
//     "dividend": 0,
//     "foreign_buy": 0,
//     "foreign_flow": 0,
//     "foreign_sell": 0,
//     "frequency": 14038,
//     "marketcap": 0,
//     "value": 387196490000,
//     "shareoutstanding": 0,
//     "ann_eps": 0,
//     "ann_pe": 0,
//     "avg_price": 8390,
//     "previous": 8325,
//     "freq_analyzer": 0
//   },
//   "widget": {
//     "BBCA": {
//       "lastprice": 8350,
//       "price_change": 25,
//       "percentage_change": 0.3003
//     }
//   },
//   "OFFER-RG": {},
//   "BID-RG": {},
//   "__t": "1678865974"
// }
